<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { User } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import EditUser from './EditUser.vue';
    import ResetPassword from './ResetPassword.vue';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        user: User;
    }

    defineProps<Props>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <DataTableActions :data="user">
        <EditUser
            v-if="hasPermission(Permission.USERS_UPDATE)"
            :user="user"
        />
        <ResetPassword
            v-if="hasPermission(Permission.USERS_UPDATE)"
            :user="user"
        />
        <Delete
            v-if="hasPermission(Permission.USERS_DELETE)"
            :route="route('v2.users.destroy', user.id)"
            :query-key="[QueryKey.USERS]"
            header="users.js.delete.title"
            description="users.js.delete.content"
        />
    </DataTableActions>
</template>
